import {
	ReferenceField,
	TextField,
	useGetOne,
	useRecordContext,
	useTranslate
} from 'react-admin';
import { CallMade } from '@mui/icons-material';
import {
	Link,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow
} from '@mui/material';
import { INPUT_SOURCE, OBJECTS_TYPES } from '../../../../constants';
import { ApartmentType, BuildingType } from '../../../../types';

export const GeneralInfo = () => {
	const record = useRecordContext<ApartmentType>();
	const t = useTranslate();
	const { data: buildingData } = useGetOne<BuildingType, Error>('buildings', {
		id: record?.building_id
	});

	if (!record) return null;

	const { area, floor, apartment_number, actions, number_of_rooms } = record;
	const { location_data, number_of_floors } = buildingData || {};

	const renderData = [
		{
			title: 'Площа',
			value: `${area}м²`,
			isDisplay: true
		},
		{
			title: 'Поверх',
			value: `${floor}${number_of_floors ? `/${number_of_floors}` : ''}` || '-',
			isDisplay: Boolean(String(floor))
		},
		{
			title: 'Кількість кімнат',
			value: number_of_rooms || '-',
			isDisplay: true
		},
		{
			title: 'Номер квартири',
			value: apartment_number || '-',
			isDisplay: true
		},
		{
			title: 'Адреса',
			value: (
				<ReferenceField
					source={INPUT_SOURCE.BUILDING_ID}
					reference={OBJECTS_TYPES.BUILDINGS}
					link={false}
				>
					<Link
						sx={{
							textDecoration: 'none'
						}}
						target="_blank"
						href={location_data?.locationUrl || ''}
					>
						<Stack direction="row" alignItems="center" spacing={1}>
							<TextField
								source="address"
								color="secondary"
								sx={{ fontWeight: 'medium' }}
							/>
							<CallMade color="secondary" fontSize="small" />
						</Stack>
					</Link>
				</ReferenceField>
			),
			isDisplay: true
		},
		{
			title: 'Тип угоди',
			value: actions?.map(action => t(`form.fields.${action}`))?.join('/'),
			isDisplay: Number(actions?.length) > 0
		}
	].filter(({ isDisplay }) => isDisplay);

	return (
		<TableContainer>
			<Table size="small">
				<TableBody>
					{renderData.map(({ title, value }, index) => (
						<TableRow key={index}>
							<TableCell width={280}>{title}</TableCell>
							<TableCell sx={{ fontWeight: 'medium' }}>{value}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
